module.exports = __webpack_public_path__ + "static/img/news1.0a716643.png";